import { injectable } from "inversify";
import AIRepository from "../../repositories/AIRepository";

interface props {
    aiRepository: AIRepository;
}

@injectable()
export class GetAIEmbedURLUseCase {
    _aiRepository: AIRepository;

    constructor(_: props) {
        this._aiRepository = _.aiRepository;
    }

    public call = async (dashboardName: string): Promise<any> => {
        return await this._aiRepository.getAIEmbedURL(dashboardName);
    }
}

export const GetAIEmbedURLUseCaseName = "GetAIEmbedURLUseCaseName";